import React, { useEffect, useRef, useState } from "react";
import { useGlobalValue } from "../../state/GlobalProvider";
import { checkIfStuck } from "../../utils";
import LinkButton from "../LinkButton/LinkButton";
import styles from "./SectionTitle.module.sass";
const SectionTitle = props => {
  const {
    title,
    subtitle,
    primary = false,
    modifiers,
    sticky,
    action
  } = props;
  const {
    pushModal,
    i18n
  } = useGlobalValue();
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const TitleTag = primary ? "h2" : "h3";
  const elem = useRef(null);
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const w = elem.current.ownerDocument.defaultView || elem.current.ownerDocument.parentView || window;
    const handleScroll = () => {
      const isStuck = checkIfStuck(elem.current, "top", 0, w);
      setStuck(isStuck);
    };
    if (sticky && elem && elem.current) {
      w.addEventListener("scroll", handleScroll);
      w.addEventListener("resize", handleScroll);
      const isStuck = checkIfStuck(elem.current, "top", 0, w);
      setStuck(prevState => {
        if (prevState !== isStuck) {
          return isStuck;
        }
        return prevState;
      });
      return () => {
        w.removeEventListener("scroll", handleScroll);
        w.removeEventListener("resize", handleScroll);
      };
    }
  }, [sticky]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles["tracker"],
    ref: elem
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${sticky ? styles["sticky"] : ""} ${stuck ? styles["stuck"] : ""} ${modifiersClasses}`,
    stuck: stuck ? "true" : null
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["details"]
  }, title && /*#__PURE__*/React.createElement(TitleTag, {
    className: styles["title"]
  }, i18n`${title}`)), /*#__PURE__*/React.createElement("div", {
    className: styles["actions"]
  }, action && action.data && /*#__PURE__*/React.createElement(LinkButton, {
    className: styles["action-button"],
    label: action.name,
    onClick: () => {
      pushModal(i18n`Raw Data`, action.data, action.view);
    }
  }))), subtitle && /*#__PURE__*/React.createElement("div", {
    className: styles["wrapText"]
  }, /*#__PURE__*/React.createElement("small", {
    className: styles["subtitle"]
  }, i18n`${subtitle}`)));
};
export default SectionTitle;